import { render, staticRenderFns } from "./OfertaConsumabile.vue?vue&type=template&id=c2b0959a&scoped=true"
import script from "./OfertaConsumabile.vue?vue&type=script&lang=js"
export * from "./OfertaConsumabile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b0959a",
  null
  
)

export default component.exports